import { render, staticRenderFns } from "./RF-Search.vue?vue&type=template&id=037da80c&scoped=true&"
import script from "./RF-Search.vue?vue&type=script&lang=js&"
export * from "./RF-Search.vue?vue&type=script&lang=js&"
import style0 from "./RF-Search.vue?vue&type=style&index=0&id=037da80c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037da80c",
  null
  
)

export default component.exports